<template>
  <div class="paytmLogin">
    <div class="loader" style="height: 40vh; position: relative; top: 250px">
      <div v-loading="is_login_loading" style=""></div>
    </div>
  </div>
</template>
<script>
import { serverAddr } from "../networkConfig";
import { loginNetworkCallBack } from "../mixins/login.NetworkCallback";

export default {
  name: "retailLanding",

  components: {},

  mixins: [loginNetworkCallBack],

  data() {
    return {
      is_login_loading: false,
      currentEnvironment: {
        width: "100px",
        utm_source: "Paytm Money",
        utm_source_str: "paytmmoney",
        logo: require("../assets/images/logo/Paytm_Money_Logo.png"),
        brokerId: 10,
        optionsTrade: true,
        isTradeAvailable: true,
        byPassLogin: false,
        loginModule: "",
        hostUrl: "paytmmoney.stockants.com",
        isHybridModel: false,
      },

      websiteUserType: {
        userType: "broker",
        userSubType: "brokerWithPlans",
      },

      userProfile: {},
      path: "",
    };
  },

  beforeRouteEnter(to, from, next) {
    // Check if the user has already logged in
    if (localStorage.getItem("profile")) {
      // Redirect to another page if the user is already logged in
      next("/data-categorisation"); // Replace "/home" with the desired route
    } else {
      next();
    }
  },

  mounted() {
    this.path = window.location.href;
    // checked token in query params and sent to server
    if (this.$route.query.requestToken) {
      let token = this.$route.query.requestToken
        ? this.$route.query.requestToken
        : "";

      this.sendTokenToServer(token);
    }

    if (this.$route.query.source) {
      localStorage.setItem("paytmSource", "app");
    }
  },

  methods: {
    selectCurrentEnvironment() {
      if (localStorage.getItem("profile")) {
        this.userProfile = JSON.parse(localStorage.getItem("profile"));
      }
      if (this.userProfile) {
        localStorage.setItem("currentEnvironment", JSON.stringify(this.currentEnvironment));
        localStorage.setItem("selected_broker", 10);
      }
    },

    selectUserType() {
      var currentUrl = window.location.href;

      this.selectCurrentEnvironment();

      localStorage.setItem("currentUrl", currentUrl);

      // brokerWithPlans means user has to pay for subscrition
      localStorage.setItem(
        "websiteUserType",
        JSON.stringify(this.websiteUserType)
      );

      // return 'select user type function call'
    },
    sendTokenToServer(token_id) {
      this.is_login_loading = true; //enabled loader

      serverAddr
        .post(`auth/v1/level_two_auth_for_broker`, {
          broker_id: 10,
          token_id: token_id,
          url: window.location.href,
          profession: "RETAIL_INVESTOR",
        })
        .then((response) => {
          if (!localStorage.getItem("currentEnvironment")) {
            this.selectUserType();
          }
          this.loginUserNetworkCallBack(response);

          this.is_login_loading = false; //disabled loader
        })
        .catch((error) => {
          console.log(error);
          this.is_login_loading = false; //disabled loader
        });
    },
  },
};
</script>
